<template lang="html">
  <nav ref="nav">
    <ul>
      <li :class="{ active: name === 'WardrobeClothes' }">
        <router-link id="first" :to="{ name: 'WardrobeClothes' }" exact>
          <span class="link-text">Clothes</span>
          <span class="notification">
            {{ currentWardrobe.wardrobe_products_count }}
          </span>
        </router-link>
      </li>
      <li :class="{ active: name === 'WardrobeOutfits' }">
        <router-link id="second" :to="{ name: 'WardrobeOutfits' }" exact>
          <span class="link-text">Outfits</span>
          <span class="notification">
            {{ currentWardrobe.wardrobe_outfits_count }}
          </span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  mounted() {
    this.name = this.$router.currentRoute.name;
  },

  data() {
    return {
      name: null,
    };
  },

  computed: {
    ...mapGetters(["currentWardrobe"]),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

nav {
  position: relative;
  padding-bottom: 12px;
}

nav ul {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  justify-content: center;
}

nav ul li {
  margin: 0 40px 0 0;
  transition: all 0.4s ease;
}

nav ul li:last-child {
  margin-right: 0;
}

nav ul li a {
  text-decoration: none;
  color: $primary-blue;
  text-transform: uppercase;
  display: block;
  font-weight: 600;
  letter-spacing: 0.2em;
  font-size: 14px;
  transition: all 0.4s ease;
  padding-top: 10px;
  padding-right: 0;
  padding-left: 0;
  border-top: 2px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  @include for-tablet-portrait-up {
    padding-right: 15px;
    padding-left: 15px;
  }

  .link-text {
    opacity: 0.4;
  }

  &:hover {
    .link-text {
      opacity: 0.7;
    }
  }

  &.router-link-exact-active {
    .link-text {
      opacity: 1;
    }

    .notification {
      background-color: $primary-blue;
      color: white;
    }

    border-top: 2px solid $mint-bright;
  }
}

.notification {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  margin-left: 0.75rem;
  border-radius: 50%;
  font-size: 12px;
  background-color: lighten($grey5, 5%);
  transition: 0.23s ease-in;
  color: $grey3;
  letter-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/WardrobeNav.vue